import VehicleService from '../api/vehicle-service'

export default {
    state: {
        vehicleLookup: {
            registration: null,
            make: null,
            model: null,
            colour: null
        },
        vehicleLookupSuccess: false,
        vehicleInfoValid: false
    },
    mutations: {
        populateLookup (state, vehicle) {
            state.vehicleLookup = vehicle
        },
        resetVehicle (state) {
            state.vehicleLookup = {
                registration: null,
                make: null,
                model: null,
                colour: null
            }
        },
        setRegistration (state, registration) {
            state.vehicleLookup.registration = registration
        },
        setMake (state, make) {
            state.vehicleLookup.make = make
        },
        setModel (state, model) {
            state.vehicleLookup.model = model
        },
        setColour (state, colour) {
            state.vehicleLookup.colour = colour
        },
        setLookupSuccess (state, success) {
            state.vehicleLookupSuccess = success
        },
        setVehicleInfoValid (state, vehicleInfoValid) {
            state.vehicleInfoValid = vehicleInfoValid
        }
    },
    actions: {
        async vehicleLookup (context, [registration, skipVehiclePopulate]) {
            return VehicleService.vehicleLookup(registration).then((response) => {
                context.commit('populateLookup', response.data)
                if (response.data.registration === null) {
                    if (!skipVehiclePopulate) {
                        context.commit('setRegistration', registration)
                        context.commit('setLookupSuccess', false)
                    }
                    return response
                } else {
                    context.commit('setVehicleInfoValid', true)
                    context.commit('setLookupSuccess', true)
                    return response
                }
            }).catch((error) => {
                context.commit('setLookupSuccess', false)
                context.commit('setRegistration', registration)
                return error
            })
        },
        async resetVehicle (context) {
            await context.commit('resetVehicle')
            await context.commit('setLookupSuccess', false)
        },
        async setRegistration (context, registration) {
            await context.commit('setRegistration', registration)
        },
        async setMake (context, make) {
            await context.commit('setMake', make)
        },
        async setModel (context, model) {
            await context.commit('setModel', model)
        },
        async setColour (context, colour) {
            await context.commit('setColour', colour)
        },
        async setVehicleInfoValid (context, vehicleInfoValid) {
            context.commit('setVehicleInfoValid', vehicleInfoValid)
        },
        async setLookupSuccess (context, valid) {
            context.commit('setLookupSuccess', valid)
        }
    },
    getters: { }
}
